module.exports = {"id":"192387","name":"Ciro Immobile","rating":"85","photo":"./data/images/photos/3/192387.png","club":{"name":"Lazio Rome","logo":"./data/images/clubs/LazioRome.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CiroImmobile0.json
// module id = 819
// module chunks = 0